import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoggedInUser } from './user.model';
export const UserActions = createActionGroup({
  source: 'Auth',
  events: {
    'Set User': props<{ user: LoggedInUser; goToReturnUrl: boolean }>(),
    setReturnUrl: props<{ returnUrl: string }>(),
    'Auth Error': props<{ error: unknown }>(),
    'Log Out': emptyProps(),
    Authenticate: emptyProps(),
  },
});
